import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import {
  loadConvList as loadConvListAction,
  updateProps as updatePropsAction,
  initialLoadAMsg as initialLoadAMsgAction,
} from './messagingStore/messaging-actions';
import R from 'ramda';
import Conversations from './conversations/convsContainer';
import CommentIcon from 'material-ui/svg-icons/communication/comment';

const propTypes = {
  params: PropTypes.object,
  children: PropTypes.node,
  selectedConv: PropTypes.object,
  loadConvList: PropTypes.func,
  updateProps: PropTypes.func,
  initialLoadAMsg: PropTypes.func,
  decrementUnreadCount: PropTypes.func,
  convList: PropTypes.array,
  getLatestContractingYear: PropTypes.func,
};
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
class MessagingContainer extends Component {

  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {
    const { params, selectedConv } = nextProps;
    // if (!R.eqProps('convList', nextProps, this.props) && isNilOrEmpty(this.props.convList)) {
    //   if (params.convId)
    // }
    if (!R.eqProps('selectedConv', nextProps, this.props)) {
      if (isNilOrEmpty(this.props.selectedConv) && !isNilOrEmpty(nextProps.selectedConv)) {
        if (!params.convId && !params.contractId) {
          if (selectedConv.contractId) this.context.router.push(`/messaging/${params.filter}/contract/${selectedConv.contractId}`);
          else this.context.router.push(`/messaging/${params.filter}/conversation/${selectedConv._id}`);
        }
      }
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }

  render() {
    const { children, params } = this.props;
    return (
      <div className="l-app-content l-left-nav-with-content" style={{ paddingTop: '65px', backgroundColor: 'rgb(240, 244, 247)', borderRight: '1px solid #e0e0e0' }}>
        <Conversations
          params={params}
        />
        <div className="l-left-nav-content" style={{ backgroundColor: '#f0f4f7', width: 'calc(100% - 366px)', paddingLeft: 0 }}>
        {
          children || (<div style={{ textAlign: 'center', marginTop: '230px' }}>
            <CommentIcon style={{ color: 'rgba(0, 0, 0, 0.24)', height: '56px', width: '56px' }} />
          </div>)
        }
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ messaging }) => (
  {
    ...messaging.conversations.toJS(),
  }
);
const mapDispatchToProps = ({
  loadConvList: loadConvListAction,
  updateProps: updatePropsAction,
  initialLoadAMsg: initialLoadAMsgAction,
  decrementUnreadCount: () => ({ type: 'DECREMENT_UNREAD_MESSAGES_COUNT' }),
});

MessagingContainer.contextTypes = {
  router: React.PropTypes.object.isRequired,
};
MessagingContainer.propTypes = propTypes;
export default connect(mapStateToProps, mapDispatchToProps)(MessagingContainer);



// WEBPACK FOOTER //
// ./src/app/components/messaging/messaging-container.jsx